import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,

  Typography,
  useTheme ,Theme ,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import CloseIcon from '@mui/icons-material/Close';
import { Field, Form, Formik } from 'formik';
import { useState } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import schemas from '../../../data/schemas';
import { Status } from '../../../store/config/enums';
import { RootState } from '../../../store/config/types';
import { CustomSnackbar } from '../../CustomSnackbar';
import { FormTextField } from '../../forms/FormTextField';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    dialogActions: {
      padding: '2rem 0',
    },
  }),
);

interface ShareValues {
  email: string;
}

interface ShareOptionProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  share: (email: string) => void;
}

const mapStateToProps = (state: RootState) => ({
  links: state.links,
});

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type PropsType = PropsFromRedux & ShareOptionProps;

function ShareOptions({ links, open, setOpen, share }: PropsType) {
  const classes = useStyles(useTheme());

  const [sharingLink, setSharingLink] = useState<boolean>(false);
  const closeDialog = () => {
    setOpen(false);
  };
  const submitLink = (values: ShareValues) => {
    setSharingLink(true);
    share(values.email);
  };
  const closeSnack = () => {
    setSharingLink(false);
    closeDialog();
  };
  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      className="dialog"
      maxWidth="xs"
      classes={{ paper: classes.container }}
    >
      <DialogTitle classes={{ root: 'dialog-title' }}>
        <CloseIcon fontSize="medium" className="icon" onClick={closeDialog} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="h4" component="p">
          Compartir por email
        </Typography>
        <Formik
          initialValues={{
            email: '',
          }}
          onSubmit={submitLink}
          validationSchema={schemas.ShareLinkSchema}
        >
          <Form className="form">
            <Field
              name="email"
              component={FormTextField}
              type="email"
              placeholder="Email"
              className="form-row"
            />
            <DialogActions className={classes.dialogActions}>
              <Button type="submit" variant="contained" color="primary" fullWidth disableElevation>
                Enviar link
              </Button>
            </DialogActions>
          </Form>
        </Formik>
      </DialogContent>
      <CustomSnackbar
        open={sharingLink && (links.shareLinkSuccess || links.shareLinkErrorMessage !== null)}
        message={
          links.shareLinkSuccess
            ? 'Se compartió el link correctamente.'
            : 'Ocurrió un error al compartir el link.'
        }
        handleClose={closeSnack}
        type={links.shareLinkSuccess ? Status.SUCCESS : Status.ERROR}
      />
    </Dialog>
  );
}

export default connector(ShareOptions);
